import React from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import { Container } from "react-bootstrap";
const RefundPolicy = () => {
  return (
    <>
      <SectionHeader
        title="Refund Policy"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Refund Policy"
        content="At BOLT-CORP, customer satisfaction is our priority. If you're
              still trying to get more satisfied with your purchase, we're here
              to help."
      ></SectionHeader>
      <div className="pt-5">
        <Container>
          <div className="pt-5 pb-4">
            <p>
              <strong>Return Eligibility: </strong>
              We accept returns for items that are in unused, undamaged, and
              resellable condition. You must initiate the return request within
              30 days of receiving the product. Certain products, such as
              custom-made or special order items, may not be eligible for
              return.
            </p>
            <p>
              <strong>Process for Returns: </strong>
              To start a return, please get in touch with our customer service
              team at [contact information]. Include your order number and the
              reason for your return. We will guide you through the return
              process and provide the necessary instructions.
            </p>
            <p>
              <strong>Refunds : </strong>
              Once your return is received and inspected, we will notify you of
              the approval or rejection of your refund. Your refund will be
              processed and applied to your original payment method within 7–10
              business days if approved.
            </p>
            <p>
              <strong>Shipping Costs: </strong>
              Please note that shipping costs for returning items are the
              customer's responsibility unless the return is due to a defective
              product or an error on our part. In this case, BOLT-CORP will
              cover return shipping costs.
            </p>
            <p>
              <strong>Damaged or Defective Items: </strong>
              If you receive a damaged or defective item, please get in touch
              with us immediately. We will arrange for a replacement or refund,
              depending on the circumstances.
            </p>
            <p>
              <strong>Non-Refundable Items: </strong>
              Some products, such as clearance items or gift cards, may not be
              eligible for refunds. Please check the product description at the
              time of purchase for more details.
            </p>
            <p>
              <strong>Changes to the Refund Policy: </strong>
              BOLT-CORP reserves the right to update or modify this policy at
              any time. Any changes will be posted on this page with the updated
              date.
            </p>
            <p>
              Please get in touch with our customer service team if you have any
              questions regarding your return or refund. We're happy to assist
              you!
            </p>
          </div>
        </Container>
      </div>
    </>
  );
};

export default RefundPolicy;
